<script lang="ts">
	import { CIRCLE_DIAMETER } from '../../../utils/constants';
	import { LightenDarkenColor } from '../../../utils/colors';
	import type { Collection, Element } from 'src/utils/types';

	export let color = '#454545';
	export let background = '';
	export let collection: Collection;
</script>

<div
	class="symmetrical-item"
	style="left:{50 / 2 - CIRCLE_DIAMETER / 2}px;
			width:{CIRCLE_DIAMETER}px;
			height:{CIRCLE_DIAMETER}px;
			top:{50 / 2 - CIRCLE_DIAMETER / 2}px;
			border : {LightenDarkenColor(color, 60)} solid 4px;
            {background ? `background-color:${background}` : ``};
			z-index:100;
			filter:saturate({collection.selected ? '130%' : '100%'});
			"
/>

<style>
	.symmetrical-item {
		user-select: none;
		box-sizing: border-box;
		position: absolute;
		border-radius: 20px;
		top: 25px;
		width: 20px;
		height: 20px;
		z-index: 3;
	}
</style>
